module.exports = __webpack_public_path__ + "img/active_point.16663cc.svg";